<script setup>
import {computed} from 'vue'
import {useViewStore} from '@/stores/view'

const props = defineProps({
    value: String,
    item: Object,
    column: Object,
    viewId: String
})

// Dynamic View Store
const viewStore = useViewStore(props.viewId)

const tableName = computed(() => viewStore.tableName)

const formattedValue = computed(() => {
    let currency = 'gbp'

    // Supports Fly Spain's currency field within the Orders component
    if (tableName.value === 'm_basket_orders' && props.item.currency) {
        currency = props.item.currency
    }

    // Currency fields can be set with null values, so only output a
    // formatted value if the value is 0.00 or higher.
    if (props.value !== null) {
        return new Intl.NumberFormat('en-IN', {
            style: 'currency',
            currency: currency
        }).format(props.value)
    }
})
</script>

<template>
    <span>{{ formattedValue }}</span>
</template>